import { useQuery } from "react-query";
import { getEventPeriod, getEventPeriodsList } from "../api";
import useOrganizationContext from "../../hooks/useOrganizationContext";

export const useEventPeriodsList = ({
	eventId,
	queryParams = {},
	options = {}
}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	return useQuery(
		["event-period-list", organizationId, eventId, queryParams],
		() =>
			getEventPeriodsList(organizationId, eventId, queryParams).then(
				({ response }) => response
			),
		{ ...options, enabled: !!eventId }
	);
};

export const useEventPeriod = ({
	eventId,
	id,
	params = null,
	options = null
}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	return useQuery(
		["event-period", organizationId, eventId, id, params],
		async () => {
			const res = await getEventPeriod({
				organizationId,
				eventId,
				id,
				params
			});

			return res.response;
		},
		{
			...options,
			enabled: (options?.enabled ?? true) && Boolean(organizationId)
		}
	);
};
